import { VerifyByMHNAndDateOfBirthResponse } from './verifyByMHNAndDateOfBirthResponse';

const mockData = {
  patientIdentityVerified: true,
  phoneNumbers: {
    '1850799424': '(XXX) XXX-5520',
    '2042747005': '(XXX) XXX-7277',
  },
};

export const VerifyByMHNAndDateOfBirthServiceMock: VerifyByMHNAndDateOfBirthResponse =
  {
    data: mockData,
    succeeded: true,
  };
